export default {
    data() {
        return {
        }
    },

    methods: {

        changeRoleSchma(schemaName, properties, rolesNot, roles, role) {

            const propertiesNames = Object.keys(properties)

            switch(schemaName){
                case 'SalesOrder':
                    propertiesNames.forEach((name) => {
                        if(!rolesNot.includes(name)){
                            properties[name].readonly = role
                        } 
                        
                        if(roles.includes(name)) {
                            properties[name].readonly = !role
                        }
                    })
                    break;

                case 'Project':

                    propertiesNames.forEach((name) => {
                        if(!rolesNot.includes(name)){
                            properties[name].readonly = role
                        }
                        
                        if(roles.includes(roles)) {
                            properties[name].readonly = !role
                        }
                    })
                    break;

                case 'OrdemDeFabricacao':

                    propertiesNames.forEach((name) => {
                        if(!rolesNot.includes(name)){
                            properties[name].readonly = role
                        }
                        
                        if(roles.includes(roles)) {
                            properties[name].readonly = !role
                        }
                    })
                    break;
            }

            return properties
        }
    }
}